export default "__VITE_ASSET__BK2S7XX5__"